// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2429) return "static/chunks/2429.92d68157cdbf76bd.js";
	if (chunkId === 1372) return "static/chunks/1372.1c3db54ae4ed37f7.js";
	// return url for filenames based on template
	return "static/chunks/" + {"3845":"e1efa4cc","4872":"72585f70","8917":"f36c6662"}[chunkId] + "-" + {"3845":"5d8beba29ac06741","4872":"41fb37f4908b1990","8917":"829fd448c05bec6c"}[chunkId] + ".js";
};